import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "onKeyup", "placeholder"]

import { ref } from 'vue'
import SearchIcon from '@/assets/SearchIcon.svg'
import Union from '@/assets/Union.svg'
import { debounce } from '@/utils/debounce'


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    modelValue: null,
    placeholder: null,
    active: { type: Boolean },
    showClearButton: { type: Boolean }
  },
  emits: ["search", "focus", "emptyClear", "update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'search'): void
  (event: 'focus'): void
  (event: 'emptyClear'): void
  (event: 'update:modelValue', term: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: string
  placeholder: string
  active: boolean
  showClearButton: boolean
};





const searchInput = ref<HTMLInputElement | null>(null)
// Simulate clicking on text input when logo is clicked
const onIconClick = () => {
  if (searchInput.value) {
    searchInput.value.focus()
  }
}

const clearSearch = () => {
  if (searchInput.value) {
    if (props.modelValue !== '') {
      searchInput.value.value = ''
      onInput()
      searchInput.value.focus()
    } else {
      emits('emptyClear')
    }
  }
}

const onSearch = () => {
  emits('search')
}

const debounceUpdate = debounce(onSearch, 300)

const onSearchFocus = () => {
  emits('focus')
}

const onInput = () => {
  if (searchInput.value) {
    emits('update:modelValue', searchInput.value.value)
    debounceUpdate()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["search-bar", { 'search-bar--active': __props.active }])
  }, [
    _withDirectives(_createElementVNode("span", {
      class: "search-bar__search-icon",
      onClick: onIconClick
    }, [
      _createVNode(_unref(SearchIcon))
    ], 512), [
      [_vShow, !__props.active]
    ]),
    _createElementVNode("input", {
      ref_key: "searchInput",
      ref: searchInput,
      class: _normalizeClass(["search-bar__input", { 'search-bar__input--active': __props.active }]),
      value: __props.modelValue,
      onInput: onInput,
      onFocus: onSearchFocus,
      onKeyup: _withKeys(onSearch, ["enter"]),
      placeholder: __props.placeholder
    }, null, 42, _hoisted_1),
    _withDirectives(_createElementVNode("span", {
      class: "search-bar__clear-button",
      onClick: clearSearch
    }, [
      _createVNode(_unref(Union))
    ], 512), [
      [_vShow, __props.showClearButton]
    ])
  ], 2))
}
}

})